"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectFormSummary = void 0;
const base_1 = require("./base");
class IkeObjectFormSummary extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'FormSummary';
        this.actionName = 'form.summary';
        this.cacheKeys['revision'] = true;
    }
}
exports.IkeObjectFormSummary = IkeObjectFormSummary;
//# sourceMappingURL=form.summary.object.js.map